import { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from './firebase';

function mapFirebaseError(err) {
  const code = err && err.code;
  if (code === 'auth/invalid-email') return 'Email không hợp lệ';
  if (code === 'auth/weak-password') return 'Mật khẩu tối thiểu 6 ký tự';
  if (code === 'auth/wrong-password' || code === 'auth/invalid-credential') return 'Sai email hoặc mật khẩu';
  if (code === 'auth/email-already-in-use') return 'Email đã được dùng với mật khẩu khác';
  return (err && err.message) || 'Đăng nhập thất bại';
}

function GoogleLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleLoginSuccess = (credentialResponse) => {
    const idToken = credentialResponse.credential;

    // Lưu token vào localStorage (hoặc context)
    localStorage.setItem('google_id_token', idToken);

    // Redirect về Home
    navigate('/');
  };

  // Đăng nhập chung hệ sinh thái tuandv.id.vn (Firebase) — dùng chung key localStorage
  // 'google_id_token' với luồng Google cũ để không phải sửa apiClient.js's interceptor.
  const handleFirebaseSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim() || !password) {
      setError('Nhập email và mật khẩu');
      return;
    }
    setBusy(true);
    try {
      let cred;
      try {
        cred = await signInWithEmailAndPassword(auth, email.trim(), password);
      } catch (err) {
        if (err.code === 'auth/user-not-found' || err.code === 'auth/invalid-credential') {
          cred = await createUserWithEmailAndPassword(auth, email.trim(), password);
        } else {
          throw err;
        }
      }
      const idToken = await cred.user.getIdToken();
      localStorage.setItem('google_id_token', idToken);
      navigate('/');
    } catch (err) {
      setError(mapFirebaseError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <h2>Đăng nhập</h2>
      <p style={{ fontSize: 13, color: '#666' }}>Dùng chung tài khoản với cả hệ sinh thái tuandv.id.vn.</p>

      <form onSubmit={handleFirebaseSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 280 }}>
        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
        <input type="password" placeholder="Mật khẩu" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
        {error && <p style={{ color: '#c0392b', fontSize: 13 }}>{error}</p>}
        <button type="submit" disabled={busy}>{busy ? 'Đang xử lý...' : 'Đăng nhập / Đăng ký'}</button>
      </form>

      <p style={{ fontSize: 12, color: '#999', margin: '16px 0 8px' }}>hoặc</p>
      <GoogleLogin
        onSuccess={handleLoginSuccess}
        onError={() => console.log('Login Failed')}
      />
    </div>
  );
}

export default GoogleLoginPage;
